export default function oppCreateQuoteFromTemplate(data){
    this.popup("oppCreateQuoteFromTemplate", {
        params: data, 
        header : this.translate("LBL_SELECT_TEMPLATE", "Opportunities")
    });
} 